import './NewsItem.css'

const NewsItem = ({ url, title, img }) => {
    const redirect = () => {
        if (url) {
            window.open(url)
        }
    }

    return (
        <div className='news-item'>
            <h2 style={{ cursor: url ? 'pointer' : 'auto' }} onClick={redirect}> {title} </h2>
            {img &&
                <div className='image-container'>
                    <img src={img} />
                </div>
            }
        </div>

    )
}

export default NewsItem;